<style scoped>
    .main{
        padding-top: .98rem;
        height: 100vh;
        background: #fff;
    }
    .iconBg{
        width: 2.4rem;
        height: 2.4rem;
        background: #E1F1FF;
        margin: 1rem auto;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .iconBg2{
        width: 2.4rem;
        height: 2.4rem;
        background: #E1F1FF;
        margin: 1rem auto;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
    }
    .word{
        font-size: .3rem;
        color: #000;
        text-align: center;
        margin: .55rem 0 .74rem;
    }
    .btn{
        background: #369AF0;
        width: 2.6rem;
        height: .8rem;
        border-radius: .4rem;
        font-size: .3rem;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
    }
    .aircraft{
        width: 1.24rem;
        height: 1.09rem;
        object-fit: cover;
        position: relative;
        transition: all 4s;
        top: 0;
        right: 0;
        z-index: 10000;
    }
    .aircraft.active{
        top:-2rem;
        right: -4rem;
        opacity: 0;
    }
    .sendSuccess{
        width: 1.04rem;
        height: 1.12rem;
        object-fit: cover;
        opacity: 0;
        transform: scale(0,0);
        transition: all 4s;
        /*margin-left: .2rem;*/
        position: relative;
    }
    .sendSuccess.active{
        opacity: 1;
        transform: scale(1,1);
    }
</style>
<template>
    <div class="main">
        <topbar text="测试结果"></topbar>
        <div class="testBox">
            <div class="iconBg">
                <img src="~assets/aircraft.png" alt="" class="aircraft" :class="{active:status}">

                <div class="iconBg2">
                    <img src="~assets/sendSuccess.png" alt="" class="sendSuccess" :class="{active:status}">
                </div>
            </div>
            <div class="word">提交成功</div>
            <div class="btn" @click="to(`mentalExperience?comboId=${comboId}&groupId=${groupId}`)">返回心理体检</div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                status:false,
                status2:false,
                comboId:this.$route.query.comboId?this.$route.query.comboId:'',
                groupId:this.$route.query.groupId?this.$route.query.groupId:''
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

            to(n) {
                this.$router.push(`/${n}`)
            },
        },
        destroyed() {

        },
        mounted() {
            setTimeout(()=>{
                this.status=true;
            },1000)
            setTimeout(()=>{
                this.status2=true
            },5000)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/testResult.vue?74ae2528